export default __webpack_public_path__ + "static/media/backImg.a0fb56de.svg";